import { render, staticRenderFns } from "./CompanyTrainingPort.vue?vue&type=template&id=4e42c245&scoped=true"
import script from "./CompanyTrainingPort.vue?vue&type=script&lang=js"
export * from "./CompanyTrainingPort.vue?vue&type=script&lang=js"
import style0 from "./CompanyTrainingPort.vue?vue&type=style&index=0&id=4e42c245&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e42c245",
  null
  
)

export default component.exports